import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'jalali-moment';

import { LocalStorage } from '../../../services';
import { _get, _post, _SERVER_URL_ } from '../../../utils/network';
import { commafy, typeChecker } from '../../../utils/methods';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ReferralChangesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('referral_changes'), link: '/referral-changes-list' },
		{ title: t('list') }
	];

	const [referralChanges, setReferralChanges] = useState([]);
	let referralChangesListData = {
		head: [
			t('user'),
			t('old_code'),
			t('new_code'),
			t('date')
		],
		body: referralChanges.map(referralChange => [
			<Link className='' to={`/users-edit/${referralChange.user_id}`} target="_blank">
				{referralChange.user_info.user_fullname} - {referralChange.user_info.national_code}
			</Link>,
			referralChange.old_code,
			referralChange.new_code,
			moment(referralChange.create_date?.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD')
		]),
		directions: ['rtl', 'ltr', 'ltr', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getReferralChange = async () => {
		let body = {
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/referralChanges/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_referralChanges);
				setReferralChanges(response.data.referralChanges);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getReferralChange();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t('referral_changes')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={referralChangesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ReferralChangesList;
